module.exports = __webpack_public_path__ + "media/images/socials/pinterest-02b0cfd68aa40cc69397a2a0bbe36c8d.png";